var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M19.875 18.749a1.124 1.124 0 1 1 0 2.25H4.125a1.124 1.124 0 1 1 0-2.25ZM12 3c.664 0 1.2.528 1.2 1.182v8.966l2.751-2.71a1.21 1.21 0 0 1 1.697 0c.47.462.47 1.21 0 1.671l-4.798 4.727a1.218 1.218 0 0 1-1.7 0l-4.798-4.727a1.17 1.17 0 0 1 0-1.671c.234-.23.541-.346.848-.346s.615.115.849.346l2.751 2.71V4.182A1.19 1.19 0 0 1 12 3"
})));
export default SvgGemDownload;